<template>
  <el-card :body-style="{ padding: '0px' }">
    <img :src="template.photo || defaultPhoto" class="image" />
    <p>{{ template.name }}</p>
    <el-link class="link" :href="templateUrl" type="primary">
      Personalizuj
    </el-link>
  </el-card>
</template>

<script>
export default {
  name: 'TemplateTile',
  props: {
    template: {
      required: true,
    },
    urlSuffix: {
      required: false,
      default: ''
    }
  },
  data() {
    return {
      defaultPhoto:
        'https://lilyzaproszenia.pl/uploads/products/resize/480-480/Poz%C5%82acane-zaproszenie-%C5%9Blubne-Gold-Speck-1.JPG.jpg',
    };
  },
  computed: {
    templateUrl() {
      return `/editor/${this.template.code}${this.urlSuffix}`;
    },
  },
};
</script>

<style lang="less">
.el-card {
  img {
    width: 100%;
    height: auto;
  }
}

.el-link.el-link--primary {
  font-weight: 600;
  font-size: 16px;
  text-decoration: none;
  margin: 10px;
}
</style>
